import * as yup from 'yup';

export const ContentSourceFormValidation = yup.object().shape( {
  name: yup
    .string()
    .required( 'Source Name is required.' )
    .strict( true )
    .matches( /^\S+$/, 'Source Name must not contain spaces' )
    .matches( /^(?:(?!\.).)*$\r?\n?/, 'Source Name must not contain periods' )
    .min( 2, 'Source Name must be a minimum of 2 characters' )
    .max( 32, 'Source Name must be a maximum of 32 characters' ),
  ddexPartyId: yup
    .string()
    .strict( true )
    .uppercase( 'All characters must be uppercase' )
    .matches( /^\S+$/, 'DDEX Party ID must not contain spaces' )
    .matches( /^[A-Za-z0-9 ]+$/, 'DDEX Party ID must not contain special characters' )
    .min( 18, 'DDEX Party ID must be exactly 18 characters' )
    .max( 18, 'DDEX Party ID must be exactly 18 characters' ),
} );
